export default function About() {
  return (
    <div>About</div>
  )
}
